import { EventCenterInfoCard } from "./EventCenterInfoCard";

export default {
  title: "SecurityPortal/Events/EventCenterInfoCard",
  component: EventCenterInfoCard,
  decorators: [
    (Story) => (
      <div
        style={{
          backgroundColor: "white",
          color: "black",
          fontFamily: "Helvetica Neue",
          height: "108px",
          width: "1103px",
        }}
      >
        <Story />
      </div>
    ),
  ],
};

const Template = (args) => <EventCenterInfoCard {...args} />;

export const Default = Template.bind({});
Default.args = {
  centerInfo: {
    address1: "Address 1",
    address2: "Address 2",
    phoneNumber: "000-000-0000",
    email: "name@email.com",
    emergencyContact: "Emergency Contact",
  },
  onSave: (value) => console.log(value),
};
